import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'absoluteUrl',
  standalone: false
})
export class AbsoluteUrlPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const regex = RegExp('^https?://', 'i');
    if (!regex.test(value)) {
      return `http://${value}`;
    }
    return value;
  }
}
